import {Flex, Image, Text} from '@chakra-ui/react';
import {FC} from 'react';
import {TranslationKeys} from 'translations';

import {Price} from '../../../price';

interface IProps {
  price: number;
  t: (term: TranslationKeys) => string;
  count: number;
  isDesktop: boolean;
  onClick: () => void;
  isMetro?: boolean;
}

export const GlobalCart: FC<IProps> = ({isDesktop, price, t, count, onClick, isMetro}) => {
  return (
    <Flex w="100%" justifyContent="space-between" onClick={onClick} h={['40px', 'auto']} alignItems="center">
      <Price value={price} priceProps={{fontSize: isDesktop ? '24px' : '18px'}} />
      <Text fontSize={['18px', '24px']}>{t('CART')}</Text>
      <Flex alignItems="center">
        <Image w={['25px', '30px']} h={['25px', '30px']} src="/basket-white-icon.svg" alt="icon" />
        <Flex
          justifyContent="center"
          alignItems="center"
          bg="#F6009B"
          w={['25px', '30px']}
          h={['25px', '30px']}
          borderRadius="50%"
          border={isMetro ? 'none' : '1px solid white'}
          ml="10px"
        >
          <Text fontSize={['16px', '18px']} color="white">
            {count}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
